export default __webpack_public_path__ + "static/media/no-results.4bee3c6b.svg";